import ReactTooltip from 'react-tooltip';
import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import usersActionCreators from '../../store/users/action-creators/index';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';

import './Oits.scss';
import Modal from "../../../shared/ui/Modal";
import AssignFtoToPhase from "./AssignFtoToPhase";
import oitsActionCreators from "../../store/oits/action-creators/oits";
import StartOitTraining from "./StartOitTraining";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import DisplayUserPhoto from "../users/DisplayUserPhoto";
import StartVacation from "./StartVacation";
import FinishVacation from "./FinishVacation";
import TrainingNotes from "./TrainingNotes";
import TrainingNotesCreate from "./TrainingNotesCreate";
import {ApiDelete, ApiGet, ApiGetRaw, ApiPatch, ApiPost} from "../../../shared/services/api-service";
import {addWeeksToDate, datediff, formatDate} from "../../../shared/services/utils/utils";
import CustomForm from "../../../shared/components/form/CustomForm";
import PhaseSummary from "./PhaseSummary";
import SignActorsManage from "./SignActorsManage";
import moment from "moment";
import Select from "react-select";
import LoadingButton from "../../../shared/ui/LoadingButton";
import {validateRequired} from "../../../shared/components/form/ValidationFunctions";

const projectedDateColor = {
  late: '#8c0a0a',
  medium: '#c79425',
  default: '#28912c'
}
class OitIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchWord: '',
      sort: {
        prop: 'lastName',
        direction: 'asc',
      },
      filterByStatus: 'opened',
      filterByCoordinator: '',
      selectedOitGuid: null,
      selectedTrainingTrackerGuid: null,
      trainingNotes: [],
      isLoading: false,
      isAddVacationOpened: false,
      isFinishVacationOpened: false,
      selectedOitVacation: null,
      showAddTrainingNotesDialog: false,
      showEditTrainingNotesDialog: false,
      editingNote: null,
      isProjectedPhaseEndOpened: false,
      phase: null,
      phaseSummary: null,
      showPhaseSummaryDialog: false,
      phaseSummaryOit: null,
      signActorsOitId: null,
      assignCoordinatorOitId: null,
      nextPhase: null,
      showManageSignActorsDialog: false,
      showAssignCoordinatorDialog: false,
      selectedOitCoordinator: null,
      selectedFto: null,
      showSendFtoMessageDialog: false
    };
  }

  componentDidMount() {
    if(this.props.userContext.hasScope(['ftoc', 'sup'])) {
      this.props.fetchUsers()
    }
  }

  // ----------------------
  // Methods
  // ----------------------

  onShowUserDetails(userGuid) {
    this.props.setSelectedUser(userGuid);
    this.props.history.push(`/users/${userGuid}`);
  }

  getOpenPhase(trainingPhases) {
    return trainingPhases.find(tp => tp.status === 'opened' || tp.status === 'remedial');
  }

  getNextPhase(trainingPhases) {
    let openedPhase = this.getOpenPhase(trainingPhases)
    if(!openedPhase) {
      return null
    }
    let nextPhase = trainingPhases.find(tp => tp.sequence > openedPhase.sequence && tp.status === 'pending')
    if(!nextPhase) {
      return trainingPhases.find(tp => tp.sequence > openedPhase.sequence)
    }
    return nextPhase;
  }

  isTrainingCompleted(trainingTracker, trainingPhases) {
    return (trainingTracker
      && trainingTracker.status === 'closed')
      || (trainingPhases.length > 0 && trainingPhases.filter((phase) => phase.status === 'completed').length === trainingPhases.length)
  }

  isTrainingTerminated(trainingTracker) {
    return trainingTracker && trainingTracker.status === 'terminated'
  }

  isTrainingResigned(trainingTracker) {
    return trainingTracker && trainingTracker.status === 'resigned'
  }

  isTrainingStarted(trainingTracker) {
    return trainingTracker && trainingTracker.status === 'opened'
  }

  isTrainingPaused(trainingTracker) {
    return trainingTracker && trainingTracker.status === 'paused'
  }

  activateOit(tp) {
    this.setState({
      isLoading: true
    },() => {
      this.props.startOitTraining(this.selectedOit, tp)
        .then(() =>  this.props.loadOitsContainer())
        .then(() => {
          this.props.history.push('/oits/' + this.selectedOit.guid + '/training-program');
        })
        .catch(() => {
          this.setState({
            isLoading: false
          })
        })
    })

  }

  addVacation(data) {

    this.setState({
      isLoading: true
    },() => {
      this.props.addVacation({
        ...data,
        expected: !!data.expected? data.expected: undefined,
        user_guid: this.state.selectedOitVacation.guid
      })
        .then(() =>  this.props.loadOitsContainer())
        .then(() => {
          this.setState({
            isLoading: false,
            isAddVacationOpened: false
          })
        })
        .catch(() => {
          this.setState({
            isLoading: false,
          })
        })
    })

  }

  finishVacation(data) {

    let vacation = this.state.selectedOitVacation.vacations.find(v => !v.finish)
    this.setState({
      isLoading: true
    },() => {
      this.props.finishVacation({
        ...data,
        vacationId: vacation.id,
        expected: !!data.expected? data.expected: undefined,
      })
        .then(() =>  this.props.loadOitsContainer())
        .then(() => {
          this.setState({
            isLoading: false,
            isFinishVacationOpened: false
          })
        })
        .catch(() => {
          this.setState({
            isLoading: false,
          })
        })
    })

  }

  // ----------------------
  // Computed
  // ----------------------

  get isLoading() {
    return !this.props.oits || this.state.isLoading;
  }

  get isShowingList() {
    return true;
  }

  get filteredByStatus() {
    return this.props.oits.filter(this.filterOit.bind(this));
  }

  get filteredOits() {
    const searchWord = this.state.searchWord.toLowerCase();
    let filteredOits = this.filteredByStatus.filter(({firstName, lastName}) => {
      return (
        firstName.toLowerCase().includes(searchWord) ||
        lastName.toLowerCase().includes(searchWord)
      );
    });

    if (this.state.sort.prop != null) {
      filteredOits.sort(this.compareOits.bind(this));

      if (this.state.sort.direction === 'desc') {
        filteredOits = filteredOits.reverse();
      }
    }

    return filteredOits;
  }

  get sortActions() {
    // eslint-disable-next-line no-nested-ternary
    return this.state.sort.direction === 'asc' ? (
      <i className="fa fa-angle-up"/>
    ) : (
      <i className="fa fa-angle-down"/>
    );
  }

  get selectedOit() {
    return this.props.oits && this.props.oits.find(o => o.guid === this.state.selectedOitGuid);
  }

  get selectedOitSignActors() {
    return this.props.oits && this.props.oits.find(o => o.guid === this.state.signActorsOitId);
  }

  get selectedPhaseSignActors() {
    let trainingPhaseGuid = this.state.openPhase.trainingPhaseGuid
    let oit = this.selectedOitSignActors;
    return oit.trainingPhases.find(tp => tp.trainingPhaseGuid === trainingPhaseGuid)
  }

  get selectedTrainingTracker() {
    return this.props.oits
      && this.props.oits.find(o => o.trainingTracker && o.trainingTracker.trainingTrackerGuid === this.state.selectedTrainingTrackerGuid)
  }

  // ----------------------
  // Methods
  // ----------------------

  assignFtoToPhases(oit) {
    this.setState({
      selectedOitGuid: oit.guid
    })
  }
  onAssignCoordinator(oit) {
    this.setState({
      assignCoordinatorOitId: oit.trainingTracker.trainingTrackerGuid,
      showAssignCoordinatorDialog: true,
      selectedOitCoordinator: oit.trainingTracker.ftoc ? {value: oit.trainingTracker.ftoc.guid, label: `${oit.trainingTracker.ftoc.firstName} ${oit.trainingTracker.ftoc.lastName}`} :null
    })

  }

  showPhaseSummary(oit) {
    let openPhase = this.getOpenPhase(oit.trainingPhases);
    let nextPhase = this.getNextPhase(oit.trainingPhases);
    ApiGetRaw(`/api/v1/training-phases/${openPhase.trainingPhaseGuid}/count-reports`)
      .then((res) => {
        this.setState({
          openPhase: openPhase,
          nextPhase: nextPhase,
          phaseSummary: res,
          phaseSummaryOit: oit,
          showPhaseSummaryDialog: true,
        })
      })
  }

  setFlowActorsForTrainingTracker(oit) {
    this.setState({
      selectedTrainingTrackerGuid: oit.trainingTracker.trainingTrackerGuid
    })
    this.loadNotes(oit.trainingTracker.trainingTrackerGuid)
  }

  loadNotes(trainingTrackerGuid) {
    this.setState({
      trainingNotes: []
    })
    ApiGet(`/api/v1/training-tracker/${trainingTrackerGuid}/comments`)
      .then(res =>  {
        this.setState({
          trainingNotes: res
        })
      })
  }

  createNote({guid,start, week, ...data}) {
    return ApiPost(`/api/v1/training-phases/${guid}/comments`, {...data, week: parseInt(week)})
      .then((res) => {
        return this.loadNotes(this.state.selectedTrainingTrackerGuid)
      })
  }

  editNote({guid}) {

    return ApiPatch(`/api/v1/training-phases/${guid}/comments`, {...data, week: parseInt(week)})
      .then((res) => {
        return this.loadNotes(this.state.selectedTrainingTrackerGuid)
      })
  }

  deleteNote({id, trainingPhase}) {
    this.setState({
      isLoading: true
    })
    ApiDelete(`/api/v1/training-phases/${trainingPhase.guid}/comments/${id}`)
      .then(() => {
        this.setState({
          trainingNotes: this.state.trainingNotes.filter(n => n.id !== id)
        })
      })
      .finally(() => {
        this.setState({
          isLoading: false
        })
      })
  }

  closeSignFlowManage() {
    this.setState({
      selectedTrainingTrackerGuid: null
    })
  }

  closeAssignFto() {
    this.setState({
      selectedOitGuid: null
    })
  }

  getActiveFto(oit) {
    const activePhase = oit.trainingPhases.filter(phase => phase.status === 'opened');

    if (activePhase[0] && activePhase[0].fto) {
      return <div className="current-fto" onClick={() => this.openSendFtoMessageDialog(activePhase[0].fto)}>{activePhase[0].fto.firstName} {activePhase[0].fto.lastName} <i className="fa fa-comment"></i></div>;
    }
    return '';
  }

  getVacation(oit) {
    return oit.vacations && oit.vacations.find(v => !v.finish)
  }

  formatSqlDate(date) {
    let [year, month, day] = date.split('-')

    return `${month}-${day}-${year}`
  }

  setFilterBy(filterByStatus) {
    this.setState({filterByStatus});
    this.props.loadOitsContainer(null,filterByStatus, this.state.filterByCoordinator);
  }

  setFilterByCoordinator(filterByCoordinator) {
    this.setState({filterByCoordinator});
    this.props.loadOitsContainer(null,this.state.filterByStatus, filterByCoordinator);
  }

  searchOits(e) {
    const {value} = e.target;
    this.setState({searchWord: value});
  }

  filterOit(oit) {
    if (this.state.filterByStatus === 'new') {
      return !oit.trainingTracker || !oit.trainingTracker.status;
    } else if (this.state.filterByStatus === 'completed') {
      return this.isTrainingCompleted(oit.trainingTracker, oit.trainingPhases);
    } else if (this.state.filterByStatus === 'opened') {
      return (
        !oit.trainingTracker || oit.trainingTracker.status === 'opened' || oit.trainingTracker.status === 'paused' || !oit.trainingTracker.status
      ) && !this.isTrainingCompleted(oit.trainingTracker, oit.trainingPhases);
    }
    return true;
  }

  sortOits(property) {
    if (property === this.state.sort.prop) {
      if (this.state.sort.direction === 'desc') {
        this.setState({
          sort: {
            prop: property,
            direction: 'asc',
          },
        });
      } else {
        this.setState({
          sort: {
            prop: property,
            direction: 'desc',
          },
        });
      }
    } else {
      this.setState({
        sort: {
          prop: property,
          direction: 'asc',
        },
      });
    }
  }

  compareOits(oit1, oit2) {
    let comparatorField1 = oit1[this.state.sort.prop];
    let comparatorField2 = oit2[this.state.sort.prop];
    if(this.state.sort.prop === 'projectedDate') {
      let projectedDate1 = this.getProjectedPhaseEnd(oit1.trainingPhases)
      let projectedDate2 = this.getProjectedPhaseEnd(oit2.trainingPhases)
      if(projectedDate1 === null) {
        return 1
      }
      if(projectedDate2 === null) {
        return -1;
      }

      if(new Date(projectedDate1.date).getTime() < new Date(projectedDate2.date).getTime()) {
        return -1
      }
      if(new Date(projectedDate1.date).getTime() > new Date(projectedDate2.date).getTime()) {
        return 1
      }

      return 0;
    }
    if (typeof comparatorField1 === 'function') {
      comparatorField1 = comparatorField1();
    }
    if (typeof comparatorField2 === 'function') {
      comparatorField2 = comparatorField2();
    }

    if (comparatorField1.toLowerCase() < comparatorField2.toLowerCase()) {
      return -1;
    } else if (
      comparatorField1.toLowerCase() > comparatorField2.toLowerCase()
    ) {
      return 1;
    }
    return 0;
  }

  getProjectedPhaseEnd(trainingPhases) {
    try {
      let openedPhase = this.getOpenPhase(trainingPhases)
      if(openedPhase) {
        if(!!openedPhase.projected_end) {
          return {
            date: moment(openedPhase.projected_end),
            label: 'Projected end date'
          }
        }
        let nextScheduledPhaseToStart = trainingPhases
          .filter(phase => phase.status === 'pending' && phase.scheduledTo && new Date(phase.scheduledTo).getTime() > Date.now())
          .sort((p1, p2) => {
            return new Date(p1.scheduledTo).getTime() - new Date(p2.scheduledTo).getTime()
          })[0]

        if(nextScheduledPhaseToStart) {
          return {
            date: nextScheduledPhaseToStart.scheduledTo,
            label: 'Scheduled end date'
          }
        }

        let lastReportDate = openedPhase.lastScheduledReport
        if(lastReportDate) {
          return {
            date: lastReportDate,
            label: 'Last scheduled report'
          }
        }


        let openedAt = addWeeksToDate(new Date(openedPhase.openedAt), openedPhase.weeks);

        return {
          date: openedAt,
          label: 'Projected end date'
        }
      }
    } catch (ex) {
      return null;
    }


    return null;
  }

  renderProjectedDate(oit) {
    let trainingPhases = oit.trainingPhases;
    let projectedDate = this.getProjectedPhaseEnd(trainingPhases);
    if(projectedDate) {
      let color = projectedDateColor.default;
      let dateDf = datediff(new Date, new Date(projectedDate.date))
      if(dateDf < 20) {
        color = projectedDateColor.medium
      }

      if(dateDf < 10) {
        color = projectedDateColor.late
      }

      return (
        <div onClick={() => this.openProjectedPhaseEdit(oit)} style={{color, cursor: 'pointer'}}>
          <div><small>{projectedDate.label}</small></div>
          <div>{formatDate(projectedDate.date)} <i className="fa fa-edit"></i></div>
        </div>
      )
    }
    return <span>N/A</span>
  }

  openProjectedPhaseEdit(oit) {

    this.setState({isProjectedPhaseEndOpened: true, currentOitPhaseEdit: oit})
  }

  updatePhaseProjectedDate(form) {
    let openedPhase = this.getOpenPhase(this.state.currentOitPhaseEdit.trainingPhases)
    return this.props.updateProjectedStartEndDatesForPhase(form, openedPhase.trainingPhaseGuid, this.state.currentOitPhaseEdit.guid)
      .then(() => {
        this.setState({isProjectedPhaseEndOpened: false, currentOitPhaseEdit: null})
      })
  }
  selectOitCoordinator(e) {
    this.setState({
      selectedOitCoordinator: e
    })
  }

  assignCoordinator() {
    let userGuid = this.state.selectedOitCoordinator? this.state.selectedOitCoordinator.value: null;
    let trainingTrackerGuid = this.state.assignCoordinatorOitId
    this.setState({
      isAssignCoordinatorLoading: true
    })

    this.props.assignCoordinator(trainingTrackerGuid, userGuid)
      .then(() => this.props.loadOitsContainer(null,this.state.filterByStatus, this.state.filterByCoordinator))
      .then(() => {
        this.setState({
          isAssignCoordinatorLoading: false,
          showAssignCoordinatorDialog: false,
          selectedOitCoordinator: null,
          assignCoordinatorOitId: null
        })
      })
  }

  openSendFtoMessageDialog(fto) {
    this.setState({
      selectedFto: fto,
      showSendFtoMessageDialog: true
    })
  }

  sendMessageToFto(data) {
    console.log('sendMessageToFto', data, this.state.selectedFto)
    return ApiPost('/api/v1/user-messages', {
      ...data,
      user_guid: this.state.selectedFto.ftoGuid,
    }).then(() => {
      this.setState({
        selectedFto: null,
        showSendFtoMessageDialog: false
      })
    })
  }

  get areCommentsEnabled() {
    if( this.props.userContext.hasScope('fto')) {
      return this.props.settings.showCommentsForFto
    }

    return true

  }

  get coordinators() {
    return this.props.users ? this.props.users.filter(u => !!u.roles.find(r => ['ftoc', 'sup'].includes(r.scope)))
      .map(u => ({
        value: u.guid,
        label: u.getFullName()
      }))
      : []
  }

  get projectedPhaseEditConfig() {
    return {
      fields: {
        // projected_start: {
        //   type: 'date',
        //   label: 'Projected date start',
        // },
        projected_end: {
          type: 'date',
          label: 'Projected date end',
        }
      }
    }
  }

  get ftocs() {
    return this.props.oits
      .filter(oit  => oit.trainingTracker && !!oit.trainingTracker.ftoc)
      .map(oit => oit.trainingTracker.ftoc)
      .map(ftoc => ({value: ftoc.ftoGuid, label: `${ftoc.firstName} ${ftoc.lastName}`}))
      .reduce((unique, ftoc) => {
        return unique.some(item => item.value === ftoc.value)
          ? unique
          : [...unique, ftoc];
      }, []);
  }

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        <Fragment>
          {this.isShowingList &&
          !this.isLoading && (
            <Fragment>
              <div className="app-content-header">
                <h4 className="title">{this.props.oitShortLabel}</h4>
              </div>

              <div className="app-content oits">
                <form className="table-filters">
                  <div className="form-group">
                    {/* eslint-disable-next-line jsx-a11y/label-has-for */}
                    <label htmlFor="filterByType">Filter {this.props.oitLabel}</label>
                    <select
                      className="form-control"
                      id="filterByType"
                      name="filterByType"
                      onChange={event => this.setFilterBy(event.target.value)}
                      value={this.state.filterByStatus}
                    >
                      <option value="opened">In progress</option>
                      <option value="new">New</option>
                      <option value="completed">Completed</option>
                      <option value="all">All Officers in Training</option>
                    </select>
                  </div>
                  {this.props.userContext.hasScope(['ftoc', 'sup']) && <div className="form-group">
                    {/* eslint-disable-next-line jsx-a11y/label-has-for */}
                    <label htmlFor="filterByType">Filter {this.props.ftocLabel}</label>
                    <select
                      className="form-control"
                      id="filterByCoordinator"
                      name="filterByCoordinator"
                      onChange={event => this.setFilterByCoordinator(event.target.value)}
                      value={this.state.filterByCoordinator}
                    >
                      <option value={''}>Show all</option>
                      <option value={this.props.userContext.userGuid}>Assigned to me</option>
                      {this.ftocs.map(ftoc => (
                        <option value={ftoc.value}>{ftoc.label}</option>
                      ))}
                    </select>
                  </div>}
                  <div className="form-group">
                    <input
                      className="form-control"
                      type="text"
                      value={this.state.searchWord}
                      placeholder="Search trainees"
                      onChange={e => this.searchOits(e)}
                    />
                  </div>
                </form>

                {!this.props.oits.length ? (
                  <h1>No {this.props.oitLabel}s found</h1>
                ) : (
                  <div className="table-scrollable">
                    <table className="table table-small table-striped layout-auto">
                      <thead>
                      <tr>
                        <th style={{width: "90px"}}>
                          <div className="header">
                            <span>Photo</span>
                          </div>
                        </th>
                        <th onClick={() => this.sortOits('lastName')}>
                          <div className="header">
                            <span>{this.props.oitShortLabel}</span>
                            {this.state.sort.prop === 'lastName' && <div className="filterActions">
                              {this.sortActions}
                            </div>}
                          </div>
                        </th>
                        <th>
                          <div className="header">
                            <span>Program Title </span>
                          </div>
                        </th>
                        <th>
                          <div className="header">
                            <span>CURRENT PHASE {this.props.ftoShortLabel}</span>
                          </div>
                        </th>

                        <th>
                          <div className="header">
                            <span>Progress</span>
                          </div>
                        </th>
                        <th onClick={() => this.sortOits('projectedDate')}>
                          <div className="header">
                            <span>PROJECTED END OF PHASE</span>
                            {this.state.sort.prop === 'projectedDate' && <div className="filterActions">
                              {this.sortActions}
                            </div>}
                          </div>
                        </th>
                        <th>
                          <div className="header">
                            <span>Coordinator</span>
                          </div>
                        </th>
                        <th>
                          <div className="header">
                            <span>Actions</span>
                          </div>
                        </th>
                        {this.areCommentsEnabled && <th>
                          <div className="header">
                            <span>Comments</span>
                          </div>
                        </th>}
                      </tr>
                      </thead>

                      <tbody>
                      {this.filteredOits.map(oit => (
                        <tr key={oit.guid}>
                          <td style={{padding: '8px 12px'}}>
                            <DisplayUserPhoto
                              user={oit}
                            />
                          </td>
                          <td>
                            <DisplayUserPhoto
                              user={oit}
                              displayOnHover={true}
                            >
                              {oit.getFullName()}
                            </DisplayUserPhoto>
                          </td>
                          <td>{oit.trainingTracker ? oit.trainingTracker.trainingProgram.title: ''}</td>

                          <td>{this.getActiveFto(oit)}</td>

                          <td className="oit-phases">
                            {this.getOpenPhase(oit.trainingPhases) ? (
                                <div className="phase">
                                  <span className="phase-header">
                                    {this.getOpenPhase(oit.trainingPhases).header}
                                  </span>
                                  <span className="phase-status opened">
                                    {this.getOpenPhase(oit.trainingPhases).status === 'opened' ? 'in progress' : 'remedial'}
                                  </span>
                                </div>
                              )
                              : this.isTrainingCompleted(oit.trainingTracker, oit.trainingPhases)
                                ? (
                                  <span className="badge badge-success">
                                     COMPLETED
                                    </span>
                                )
                                : this.isTrainingTerminated(oit.trainingTracker)
                                  ? (<span className="badge badge-danger">
                                    TERMINATED
                                  </span>)
                                  : this.isTrainingResigned(oit.trainingTracker) ?
                                    (<span className="badge badge-danger">
                                     RESIGNED
                                    </span>)
                                    : this.isTrainingStarted(oit.trainingTracker)?
                                      (<span className="badge badge-danger">
                                     PHASE NOT STARTED
                                    </span>): this.isTrainingPaused(oit.trainingTracker)?
                                      (<div>
                                        <span className="badge badge-info">
                                         PAUSED
                                        </span>
                                        {this.getVacation(oit) && this.getVacation(oit).expected &&
                                          <div>Until {this.formatSqlDate(this.getVacation(oit).expected)}</div>
                                        }
                                      </div>)
                                      : (<span className="badge badge-warning">
                                     NOT STARTED
                                    </span>)

                            }
                          </td>
                          <td>
                            { this.renderProjectedDate(oit)}
                          </td>
                          {!!oit.trainingTracker && <td>
                            <LoadingButton
                              extraSmall={true}
                              text={oit.trainingTracker.ftoc ? `${oit.trainingTracker.ftoc.firstName} ${oit.trainingTracker.ftoc.lastName}` : 'Assign coordinator'}
                              icon={'fa fa-edit'}
                              secondary={!oit.trainingTracker.ftoc}
                              onClick={() => this.onAssignCoordinator(oit)}
                            />
                          </td>}
                          <td>
                            <div className="td-actions">
                              <ReactTooltip
                                place="top"
                                className="customTheme"
                                effect="solid"
                              />
                              {oit.trainingTracker && (
                                <Link to={`/oits/${oit.guid}/training-program`}>
                                  <button
                                    data-tip="View Training Program"
                                    className="button small default"
                                  >
                                    <i className="fa fa-list"/>
                                  </button>
                                </Link>
                              )}
                              {oit.trainingTracker && this.props.userContext.hasScope(['ftoc', 'sup']) && (
                                <button
                                  data-tip={`Assign/Unassign ${this.props.ftoShortLabel}`}
                                  className="button small default"
                                  onClick={() => this.assignFtoToPhases(oit)}
                                >
                                  <i className="fa fa-user-secret"/>
                                </button>
                              )}

                              {oit.trainingTracker && this.getOpenPhase(oit.trainingPhases) && this.props.userContext.hasScope(['ftoc', 'sup']) && (
                                <button
                                  data-tip={`Advance training to next phase`}
                                  className="button small default"
                                  onClick={() => this.showPhaseSummary(oit)}
                                >
                                  <i className="fa fa-fast-forward"/>
                                </button>
                              )}

                              {oit.trainingTracker && this.getOpenPhase(oit.trainingPhases) && this.props.userContext.hasScope(['ftoc', 'sup']) && (
                                <button
                                  data-tip="Set Approvers"
                                  className="button small default"
                                  onClick={() => this.setState({
                                    signActorsOitId: oit.guid,
                                    openPhase: this.getOpenPhase(oit.trainingPhases),
                                    showManageSignActorsDialog: true
                                  })}
                                >
                                  <i className="fa fa-edit"/>
                                </button>
                              )}

                              {oit.trainingTracker && this.props.userContext.hasScope(['ftoc', 'sup', 'cstaff', 'chief']) && (
                                <Fragment>
                                  {
                                    !this.isTrainingPaused(oit.trainingTracker)
                                    && !this.isTrainingCompleted(oit.trainingTracker, oit.trainingPhases)
                                    && !this.isTrainingResigned(oit.trainingTracker)
                                    && !this.isTrainingTerminated(oit.trainingTracker)
                                    && <button
                                        data-tip="Pause program/Start vacation"
                                        className="button small default"
                                        onClick={() => this.setState({
                                          isAddVacationOpened: true,
                                          selectedOitVacation: oit
                                        })}
                                      >
                                        <i className="fa fa-pause"/>
                                      </button>
                                  }


                                  {
                                    this.isTrainingPaused(oit.trainingTracker)
                                    && <button
                                      data-tip="Resume program"
                                      className="button small default"
                                      onClick={() => this.setState({
                                        isFinishVacationOpened: true,
                                        selectedOitVacation: oit
                                      })}
                                    >
                                      <i className="fa fa-play"/>
                                    </button>
                                  }
                                </Fragment>
                              )}

                              {!oit.trainingTracker && (
                                <button
                                  data-tip="Start program"
                                  className="button small default"
                                  onClick={() => this.assignFtoToPhases(oit)}
                                >
                                  <i className="fa fa-play"/>
                                </button>
                              )}
                            </div>
                          </td>
                          {this.areCommentsEnabled && <td>
                            {oit.trainingTracker && this.props.userContext.hasScope(['fto', 'ftoc', 'sup', 'cstaff', 'chief']) && (
                              <button
                                data-tip="Add/edit comments"
                                className="button small default"
                                onClick={() => this.setFlowActorsForTrainingTracker(oit)}
                              >
                                <i className="fa fa-book"/>
                              </button>
                            )}
                          </td>}
                        </tr>
                      ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </Fragment>
          )}
          <Modal
            title={this.selectedOit && `${this.selectedOit.firstName} ${this.selectedOit.lastName}`}
            onClose={() => this.closeAssignFto()}
            isOpen={!!this.selectedOit && !!this.selectedOit.trainingTracker}>
            {!this.isLoading && this.selectedOit && <AssignFtoToPhase trainingPhases={this.selectedOit.trainingPhases}/>}
          </Modal>

          <Modal
            isOpen={!!this.selectedTrainingTracker}
            onClose={() => this.closeSignFlowManage()}
            size="lg"
            title={this.selectedTrainingTracker? `Comments: ${this.selectedTrainingTracker.getFullName()}`: ''}>
            {this.selectedTrainingTracker && (
              <TrainingNotes
                trainingTracker={this.selectedTrainingTracker}
                trainingNotes={this.state.trainingNotes}
                userContext={this.props.userContext}
                onAddNotes={() => this.setState({showAddTrainingNotesDialog: true})}
                onEditNote={(n) => this.setState({showEditTrainingNotesDialog: true, editingNote: {...n, guid: n.trainingPhase.guid}})}
                deleteNote={(n) => this.deleteNote(n)}
              />
            )}
          </Modal>

          <Modal
            isOpen={!!this.selectedTrainingTracker && this.state.showAddTrainingNotesDialog}
            onClose={() => this.setState({showAddTrainingNotesDialog: false})}
            size="lg"
            title={this.selectedTrainingTracker? `Add comments: ${this.selectedTrainingTracker.getFullName()}`: ''}>
            { this.selectedTrainingTracker && this.state.showAddTrainingNotesDialog && (
              <TrainingNotesCreate
                selectedOit={this.selectedTrainingTracker}
                saveNoteAction={this.createNote.bind(this)}
                onSuccess={() => this.setState({
                  showAddTrainingNotesDialog: false,
                })}
              />
            )}
          </Modal>
          <Modal
            isOpen={!!this.selectedTrainingTracker && this.state.showEditTrainingNotesDialog}
            onClose={() => this.setState({showEditTrainingNotesDialog: false})}
            size="lg"
            title={this.selectedTrainingTracker? `Add comments: ${this.selectedTrainingTracker.getFullName()}`: ''}>
            { this.selectedTrainingTracker && this.state.showEditTrainingNotesDialog && (
              <TrainingNotesCreate
                selectedOit={this.selectedTrainingTracker}
                saveNoteAction={this.editNote.bind(this)}
                initialValues={this.state.editingNote}
                onSuccess={() => this.setState({
                  showEditTrainingNotesDialog: false,
                })}
              />
            )}
          </Modal>

          <Modal
            isOpen={!!this.selectedOit && !this.selectedOit.trainingTracker}
            title={'Start oit training'}
            onClose={() => this.closeAssignFto()}>

            <StartOitTraining onSelect={(tp) => this.activateOit(tp)}/>
          </Modal>

          <Modal
            isOpen={this.state.isAddVacationOpened}
            title={'Pause program/Start vacation'}
            onClose={() => this.setState({isAddVacationOpened: false})}
          >
            {this.state.isAddVacationOpened &&
              <StartVacation
                onSubmit={(data) => this.addVacation(data)}
              />
            }
          </Modal>
          <Modal
            isOpen={this.state.isFinishVacationOpened}
            title={'Resume program/End vacation'}
            onClose={() => this.setState({isFinishVacationOpened: false})}
          >
            {this.state.isFinishVacationOpened &&
              <FinishVacation
                onSubmit={(data) => this.finishVacation(data)}
                oit={this.state.selectedOitVacation}

              />
            }
          </Modal>
          <Modal
            isOpen={this.state.isProjectedPhaseEndOpened}
            title={'Update projected date end'}
            onClose={() => this.setState({isProjectedPhaseEndOpened: false})}
          >
            {
              <CustomForm
                config={this.projectedPhaseEditConfig}
                submitAction={(data) => this.updatePhaseProjectedDate(data)}
              />
            }
          </Modal>

          <Modal
            isOpen={this.state.showPhaseSummaryDialog}
            title={'Phase summary'}
            onClose={() => this.setState({showPhaseSummaryDialog: false, openPhase: null, phaseSummary: null, phaseSummaryOit: null, nextPhase: null})}
          >
            {this.state.showPhaseSummaryDialog && (
              <PhaseSummary
                phase={this.state.openPhase}
                nextPhase={this.state.nextPhase}
                phaseSummary={this.state.phaseSummary}
                oit={this.state.phaseSummaryOit}
                onPhaseUpdated={() => this.setState({showPhaseSummaryDialog: false, openPhase: null, phaseSummary: null, phaseSummaryOit: null, nextPhase: null})}
              />
            )}
          </Modal>
          <Modal
            isOpen={this.state.showManageSignActorsDialog}
            title={'Manage sign actors'}
            onClose={() => this.setState({showManageSignActorsDialog: false, openPhase: null, signActorsOitId: null,})}
          >
            {this.state.showManageSignActorsDialog && (
              <SignActorsManage
                oit={this.selectedOitSignActors}
                phase={this.selectedPhaseSignActors}
                onSignActorsUpdate={(signActors) => this.props.updateSignActorsForPhase(signActors, this.state.openPhase.trainingPhaseGuid)}/>
            )}
          </Modal>
          <Modal
            isOpen={this.state.showAssignCoordinatorDialog}
            title={'Assign coordinator'}
            onClose={() => this.setState({showAssignCoordinatorDialog: false, selectedTrainingTrackerGuid: null})}
          >
            {this.state.showAssignCoordinatorDialog && (
              <div style={{padding: '20px'}}>
                <Select
                  value={this.state.selectedOitCoordinator}
                  isClearable={true}
                  isSearchable={true}
                  defaultValue={null}
                  options={this.coordinators}
                  name={'value'}
                  onChange={(e) => this.selectOitCoordinator(e)}
                ></Select>
                <div style={{padding: '20px 0 0', textAlign: 'right'}}>
                  <LoadingButton isLoading={this.state.isAssignCoordinatorLoading} primary={true} text={'Save'} onClick={() => this.assignCoordinator()}/>
                </div>
              </div>
            )}
          </Modal>

          <Modal
            isOpen={this.state.showSendFtoMessageDialog}
            title={'Send message to: ' + (this.state.selectedFto ? `${this.state.selectedFto.firstName} ${this.state.selectedFto.lastName}`: '') }
            onClose={() => this.setState({showSendFtoMessageDialog: false, selectedFto: null})}
          >
            {this.state.showSendFtoMessageDialog && (
              <CustomForm
                config={{fields: {
                  message: {
                    type: 'textarea',
                    label: 'Message',
                    rules: [validateRequired('Message')]
                  }}}}
                submitAction={(data) => this.sendMessageToFto(data)}
              />
            )}
          </Modal>

        </Fragment>
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isLoading: state.oits.isLoading.length > 0,
    oits: state.oits.list,
    users: state.users.usersByMaster,
    userContext: state.common.userContext,
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    oitLabel: departmentSettingsSelectors.oitLabel(state),
    ftocLabel: departmentSettingsSelectors.ftocLabel(state),
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
    settings: state.departmentSettings.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addOit: () => {
      return dispatch(usersActionCreators.addOit());
    },
    updateSignActors: (signActors, trainingTrackerGuid) => {
      return dispatch(oitsActionCreators.updateSignActors(signActors, trainingTrackerGuid))
    },
    updateProjectedStartEndDatesForPhase: (signActors, trainingTrackerGuid) => {
      return dispatch(oitsActionCreators.updateProjectedStartEndDatesForPhase(signActors, trainingTrackerGuid))
    },
    startOitTraining: (oit, tp) => {
      return dispatch(oitsActionCreators.startOitTraining(oit, tp))
    },
    addVacation: (data) => {
      return dispatch(oitsActionCreators.addVacation(data))
    },
    finishVacation: (data) => {
      return dispatch(oitsActionCreators.finishVacation(data))
    },
    assignCoordinator: (trainingTrackerGuid, userGuid) => {
      return dispatch(oitsActionCreators.assignCoordinator(trainingTrackerGuid, userGuid))
    },
    loadOitsContainer: (scope, status, coordinator) => {
      return dispatch(oitsActionCreators.loadOitsContainer(scope, status, coordinator));
    },
    updateSignActorsForPhase: (signActors, trainingTrackerGuid) => {
      return dispatch(oitsActionCreators.updateSignActorsForPhase(signActors, trainingTrackerGuid))
    },
    fetchUsers: () => dispatch(usersActionCreators.fetchUsersByMaster())
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OitIndex));
